// based on vc-dialog 7.1.3
import DialogWrap from './DialogWrap'
export default DialogWrap



// WEBPACK FOOTER //
// ./components/vc-dialog/index.js